// Top red ticker — current season status (countdown, current week, etc.).
import { CURRENT_SEASON } from '../config/season';

export default function LiveTicker({ message, season = CURRENT_SEASON.leagueSeason }) {
  return (
    <div className="bg-gradient-to-r from-accent-red to-red-700 px-4 sm:px-6 py-1.5 text-[10px] font-black tracking-[0.2em] flex justify-between items-center gap-3 overflow-hidden">
      <span className="min-w-0 truncate">● {message}</span>
      <span className="text-accent-gold shrink-0">▸ SEASON {String(season).padStart(2, '0')}</span>
    </div>
  );
}
